import { Button, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { IHeatIndex } from 'shared/types/heatIndex';

import * as styles from './HeatIndexSection.css';
import { HeatIndexDiagram } from '../HeatIndexDiagram';

interface IHeatIndexSectionProps extends IHeatIndex {
  onClick(): void;
}

export const HeatIndexSection: React.FC<IHeatIndexSectionProps> = ({ onClick, title, description, value }) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['container']}>
        <div className={styles['info']}>
          <div>
            <div className={styles['title']}>
              <UIText1 fontWeight="bold">{title}</UIText1>
            </div>
            <div className={styles['description']}>
              <UIText1>{description}</UIText1>
            </div>
          </div>
          <div>
            <Button data-testid="heat-index-info" theme="fill_secondary" size="XS" onClick={onClick}>
              Подробнее
            </Button>
          </div>
        </div>
        <div className={styles['diagram']}>
          <HeatIndexDiagram value={value} title={value.toString()} />
        </div>
      </div>
    </div>
  );
};
